import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssContextService } from '../../jss-context.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-calculator-loan-mini',
  templateUrl: './calculator-loan-mini.component.html',
  styleUrls: ['./calculator-loan-mini.component.scss']
})
export class CalculatorLoanMiniComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  public fields:any;
  public value:number;
  public months:number;
  public monthlyPayment:number;
  public contextSubscription: Subscription;
  language:string;
  constructor(public jssContext: JssContextService) { }

  ngOnInit() {
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
    this.fields = this.rendering?.fields as any;
    this.value = this.fields?.FirstInputMin?.value;
    this.months = this.fields?.SecondInputMin?.value;
    this.calculateMonthlyPayment(this.value, this.months);
  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
        this.contextSubscription.unsubscribe();
    }
  }

  onInputChange(value: any, property: string) {
    if(property=="value"){
      this.value = value;
    }else{
      this.months = value;
    }
    this.calculateMonthlyPayment(this.value, this.months);
  }

  calculateMonthlyPayment(loanAmount: number, months: number) {
    // Υπολογισμός του μηνιαίου επιτοκίου
    var interestRate;
    if(this.fields?.RangeList?.length>0){
      for (let i = 0; i < this.fields?.RangeList.length; i++) {
        const rangeItem = this.fields?.RangeList[i];
        if(rangeItem?.fields?.MinAmount?.value <= loanAmount && rangeItem?.fields?.MaxAmount?.value >= loanAmount){
          interestRate = this.fields?.ApplyEuribor?.value ? +rangeItem?.fields?.InterestRate?.value + +this.fields?.Euribor?.fields?.Name?.value : +rangeItem.fields?.InterestRate?.value;
          break;
        }
      };
    }else{
      interestRate = this.fields?.ApplyEuribor?.value ? +this.fields?.InterestRate?.value + +this.fields?.Euribor?.fields?.Name?.value : +this.fields?.InterestRate?.value;
    }
    const monthlyInterestRate = interestRate / 100 / 12;
    
    // Υπολογισμός του παράγοντα πληρωμής
    const paymentFactor = (monthlyInterestRate * Math.pow(1 + monthlyInterestRate, months)) / (Math.pow(1 + monthlyInterestRate, months) - 1);
    
    // Υπολογισμός της μηνιαίας δόσης
    const monthlyPayment = loanAmount * paymentFactor;

    this.monthlyPayment =  +monthlyPayment.toFixed(2);
}
}
